module.exports = __webpack_public_path__ + "h5/img/sh.d28fb46a.png";